import HttpInterceptorManager from '../utils/http/interceptor'

class ExtensionsPlugin {

	constructor() {
		window.initExtensions = this.initExtensions.bind(this);
		this.extensions = {};
	}

	install(Vue, options) {

		this.options = options;
		options.extensionsPlugin = this;
		this.onRegisterExtension = options.onRegisterExtension;

		Vue.mixin({

			mounted() {
				onRender.call(this, options);
			},

			updated() {
				onRender.call(this, options);
			}
		});
	}

	getExtension(extensionName) {
		return this.extensions[extensionName];
	}

	registerExtension(extensionName, extensionCode) {

		if(! this.extensions[extensionName]) {
			this.extensions[extensionName] = [];
		}

		if(extensionName == 'addHttpInterceptor') {
			let interceptor = extensionCode();
			HttpInterceptorManager.addInterceptor(interceptor);
		}

		/* Push the extension to the array - there may be more than one extension code for a particular extension */
		this.extensions[extensionName].push(extensionCode);
		if(this.onRegisterExtension && typeof this.onRegisterExtension == "function") {
			this.onRegisterExtension(extensionName, extensionCode);
		}
	}

	initExtensions(extensionName, extensionCallback) {

		extensionCallback(this);
	}

	runExtension(extensionName, elementContext ={}, options) {
		options = options || this.options;
		let extensions = options.extensionsPlugin.getExtension(extensionName);
		if(extensions) {

			/* Add to the extensionContext the props & data of the component */
			options.extensionContext.component  = elementContext;

			/* Add to the extensionContext the props & data of the component */
			options.extensionContext.props = this.$props;
			options.extensionContext.data  = this.$data;

			/* For each extension code registered in for this extension - iterate and run */
			extensions.forEach((extension) => {
				extension(options.extensionContext, this.$el);
			});
		}
	}

}


function onRender(options) {
	/* Ge the extension name attribute of the component - if exists */
	let extensionName = this.$el.nodeType == 1 && this.$el.getAttribute('extension-name');
	if(extensionName) {

		let elementContext = {};
		if(this.getExtensionContext) {
			elementContext = this.getExtensionContext();
		}
		const _this = this;
		this.$nextTick(()=> {
			options.extensionsPlugin.runExtension.call(_this,extensionName, elementContext, options )
		});
	}
}

export default new ExtensionsPlugin();





// WEBPACK FOOTER //
// ../common/plugins/extensionsPlugin.js